import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { TreeIdCells } from './TreeIdBlock'
import { OriginalAndStandardFactBlock } from '../../commonComponents/CommonComponents'

export default () => {}

export function ReligiousMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId

  const personSummary = queueCachesState.personsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      {/* Row */}
      {messageDetails?.unwantedTerm && (
        <Cell columns={12}>
          <DataBlock heading={t('queues.unwantedTerm', 'Unwanted Term')} data={messageDetails?.unwantedTerm} />
        </Cell>
      )}
      {messageDetails?.term && (
        <Cell columns={12}>
          <DataBlock heading={t('queues.term', 'Term')} data={messageDetails?.term} />
        </Cell>
      )}

      {/* Row */}
      <Cell columns={6}>
        <DataBlock heading={t('queues.unwantedText', 'Unwanted Text')} data={messageDetails?.unwantedText} />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('queues.changeLocation', 'Change Location')} data={messageDetails?.change} />
      </Cell>

      {/* Genealogical Information */}
      <OriginalAndStandardFactBlock heading={t('birth', 'Birth')} fact={personSummary?.birth} columns={6} />
      <OriginalAndStandardFactBlock
        heading={t('christening', 'Christening')}
        fact={personSummary?.christening}
        columns={6}
      />
      {personSummary?.marriages?.length > 0 && (
        <Cell columns={6}>
          {personSummary.marriages.map((marriage) => (
            <OriginalAndStandardFactBlock
              key={marriage.value?.conclusionId}
              heading={t('marriage', 'Marriage')}
              fact={marriage}
            />
          ))}
        </Cell>
      )}
      <OriginalAndStandardFactBlock heading={t('death', 'Death')} fact={personSummary?.death} columns={6} />
    </Grid>
  )
}
